import React from "react";

export const getSensorsControllersTabType = (
    tabKey: string,
    data: any[]
): boolean => {
    if (!data || data.length === 0) return false;

    const firstRow = data[0];

    switch (tabKey) {
        case "sensors":
            return (
                typeof firstRow.sensor_name === "string" &&
                typeof firstRow.sensor_type === "string" &&
                typeof firstRow.readings === "object"
            );
        case "controllers":
            return (
                typeof firstRow.name === "string" &&
                typeof firstRow.type === "string" &&
                typeof firstRow.status === "string" &&
                !("reading" in firstRow)
            );
        default:
            return false;
    }
};

export const renderOnOffHighlightedCommon = (text: string): React.ReactNode => {
    if (!text) return "-";
    const str = String(text);
    const parts = str.split(/\b(on|off)\b/i);

    if (parts.length === 1 && !/^(on|off)$/i.test(str.trim())) {
        // Heuristic: split value from timestamp by common separators
        const todayIdx = str.indexOf(" Today");
        const yesterdayIdx = str.indexOf(" Yesterday");
        const atIdx = str.indexOf(" at ");

        let splitIdx = -1;
        if (todayIdx > -1) splitIdx = todayIdx;
        else if (yesterdayIdx > -1) splitIdx = yesterdayIdx;
        else if (atIdx > -1) splitIdx = atIdx;

        if (splitIdx > 0) {
            const valuePart = str.slice(0, splitIdx);
            const restPart = str.slice(splitIdx);
            return React.createElement(
                "span",
                null,
                React.createElement(
                    "span",
                    { style: { color: "#00cbaf" } },
                    valuePart
                ),
                restPart
            );
        }

        // No obvious timestamp separator; color the whole text
        return React.createElement(
            "span",
            { style: { color: "#00cbaf" } },
            str
        );
    }

    let keyCounter = 0;
    return React.createElement(
        "span",
        null,
        parts.map((part) => {
            const lower = part.toLowerCase();
            const isTarget = lower === "on" || lower === "off";
            const key = `onoff-${keyCounter++}`;
            if (isTarget) {
                return React.createElement(
                    "span",
                    { key, style: { color: "#00cbaf" } },
                    part
                );
            }
            return React.createElement("span", { key }, part);
        })
    );
};

